import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-light navbar-expand-md",
  style: {"background-color":"rgba(0, 0, 0, 0.03)","border":"1px solid rgba(0, 0, 0, 0.125)","border-bottom":"0"},
  role: "navigation"
}
const _hoisted_2 = { class: "navbar-nav mr-2" }
const _hoisted_3 = { class: "dropdown" }
const _hoisted_4 = { class: "navbar-form" }
const _hoisted_5 = { class: "btn-group" }
const _hoisted_6 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_7 = { class: "dropdown-menu" }
const _hoisted_8 = {
  key: 0,
  class: "dropdown ml-2"
}
const _hoisted_9 = { class: "navbar-form" }
const _hoisted_10 = { class: "btn-group" }
const _hoisted_11 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_12 = { class: "dropdown-menu" }
const _hoisted_13 = {
  key: 1,
  class: "dropdown ml-2"
}
const _hoisted_14 = {
  key: 2,
  class: "dropdown ml-2"
}
const _hoisted_15 = { class: "navbar-form" }
const _hoisted_16 = { class: "dropdown" }
const _hoisted_17 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_18 = {
  class: "dropdown-menu",
  style: {"max-height":"250px","overflow-y":"auto"}
}
const _hoisted_19 = { class: "navbar-nav ml-auto mr-2" }
const _hoisted_20 = { class: "dropdown" }
const _hoisted_21 = { class: "navbar-form" }
const _hoisted_22 = { class: "btn-group" }
const _hoisted_23 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_24 = { class: "dropdown-menu" }
const _hoisted_25 = {
  class: "form-inline my-2 my-lg-0",
  role: "search"
}
const _hoisted_26 = ["value"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "table-responsive" }
const _hoisted_29 = { class: "table table-hover" }
const _hoisted_30 = {
  class: "text-center align-middle",
  style: {"min-width":"200px","width":"200px","max-width":"200px"}
}
const _hoisted_31 = {
  class: "text-right align-middle",
  style: {"min-width":"250px","width":"auto"}
}
const _hoisted_32 = { style: {"min-width":"300px","width":"300px","max-width":"300px"} }
const _hoisted_33 = { class: "text-primary" }
const _hoisted_34 = {
  class: "text-center align-middle",
  style: {"min-width":"100px","width":"100px","max-width":"100px"}
}
const _hoisted_35 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_36 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_37 = {
  class: "text-center align-middle",
  style: {"min-width":"250px","width":"250px","max-width":"250px"}
}
const _hoisted_38 = {
  class: "btn-group mr-2",
  role: "group"
}
const _hoisted_39 = ["onClick", "disabled"]
const _hoisted_40 = ["onClick", "disabled"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["disabled", "onClick"]
const _hoisted_43 = {
  class: "text-center align-middle",
  style: {"min-width":"200px","width":"200px","max-width":"200px"}
}
const _hoisted_44 = {
  class: "text-right align-middle",
  style: {"min-width":"250px","width":"auto"}
}
const _hoisted_45 = {
  class: "progress justify-content-end",
  style: {"height":"30px"}
}
const _hoisted_46 = {
  class: "align-middle",
  style: {"min-width":"250px","width":"auto"}
}
const _hoisted_47 = {
  class: "progress",
  style: {"height":"30px"}
}
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "table-responsive" }
const _hoisted_50 = { class: "table table-hover" }
const _hoisted_51 = { style: {"min-width":"300px","width":"300px","max-width":"300px"} }
const _hoisted_52 = { class: "text-primary" }
const _hoisted_53 = {
  class: "text-center align-middle",
  style: {"min-width":"100px","width":"100px","max-width":"100px"}
}
const _hoisted_54 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_55 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_56 = {
  class: "text-center align-middle",
  style: {"min-width":"250px","width":"250px","max-width":"250px"}
}
const _hoisted_57 = {
  class: "btn-group mr-2",
  role: "group"
}
const _hoisted_58 = ["onClick", "disabled"]
const _hoisted_59 = ["onClick", "disabled"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["disabled", "onClick"]
const _hoisted_62 = { key: 2 }
const _hoisted_63 = { class: "table-responsive" }
const _hoisted_64 = { class: "table table-bordered table-hover" }
const _hoisted_65 = { style: {"min-width":"300px","width":"300px","max-width":"300px"} }
const _hoisted_66 = { class: "text-primary" }
const _hoisted_67 = {
  class: "text-center align-middle",
  style: {"min-width":"100px","width":"100px","max-width":"100px"}
}
const _hoisted_68 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_69 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_70 = {
  class: "text-center align-middle",
  style: {"min-width":"250px","width":"250px","max-width":"250px"}
}
const _hoisted_71 = {
  class: "btn-group mr-2",
  role: "group"
}
const _hoisted_72 = ["onClick", "disabled"]
const _hoisted_73 = ["onClick", "disabled"]
const _hoisted_74 = ["onClick"]
const _hoisted_75 = ["disabled", "onClick"]
const _hoisted_76 = { key: 3 }
const _hoisted_77 = { class: "table table-bordered table-hover mt-2" }
const _hoisted_78 = {
  class: "align-middle",
  style: {"min-width":"250px","width":"auto"}
}
const _hoisted_79 = {
  key: 0,
  class: "float-right"
}
const _hoisted_80 = { class: "dropdown d-inline mr-2" }
const _hoisted_81 = {
  class: "dropdown-menu dropdown-menu-right",
  role: "menu",
  style: {"width":"300px"}
}
const _hoisted_82 = { style: {"min-width":"300px","width":"300px","max-width":"300px"} }
const _hoisted_83 = { class: "text-primary" }
const _hoisted_84 = {
  class: "text-center align-middle",
  style: {"min-width":"100px","width":"100px","max-width":"100px"}
}
const _hoisted_85 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_86 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_87 = {
  class: "text-center align-middle",
  style: {"min-width":"250px","width":"250px","max-width":"250px"}
}
const _hoisted_88 = {
  class: "btn-group mr-2",
  role: "group"
}
const _hoisted_89 = ["onClick", "disabled"]
const _hoisted_90 = ["onClick", "disabled"]
const _hoisted_91 = ["onClick"]
const _hoisted_92 = ["disabled", "onClick"]
const _hoisted_93 = {
  class: "text-center align-middle",
  style: {"min-width":"150px","width":"150px","max-width":"150px"}
}
const _hoisted_94 = {
  key: 0,
  class: "progress",
  style: {"height":"30px"}
}
const _hoisted_95 = ["title"]
const _hoisted_96 = {
  key: 1,
  class: "progress",
  style: {"height":"30px"}
}

import { ref, computed } from 'vue'

    import type {
        SelectionProjectReadModel,
        SelectionCriterionReadModel,
        SelectionComparableScenarioReadModel
    } from '@Quest/PortfolioScenarios/readmodels'

    import { getDistinctBgCss, getDistinctColor, numCompare } from '@common/Common'
    import { ProjectAcceptance } from '@common/types'

    import CriterionSelectorDialog from '@Criteria/Hierarchies/Components/CriterionSelectorDialog.vue'
    import { CriterionSelectorDialogViewModel } from '@Criteria/Hierarchies/Components/CriterionSelectorDialog'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectsSelectionView',
  props: {
    propCurrencyLabel: {},
    propProjects: {},
    propAllCriteria: {},
    propComparableScenarios: {},
    propSearchPhrase: {},
    propProjectsFilter: {}
  },
  emits: ["update-search-phrase", "update-projects-filter", "accept-selection", "reject-selection", "lock-selection", "unlock-selection"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- local state ----------------

    const projectsDataView = ref<'CBA' | 'RAG' | 'Ranking' | 'H2H'>('CBA')
    const criteriaFilter = ref<'Objectives' | 'Attributes' | 'All criteria'>('Objectives')
    const valueFilter = ref<number | null>(null)
    const criterionId = ref<number | null>(null)

    const criterionSelectorDialog = new CriterionSelectorDialogViewModel()

    // ---------------- computed ----------------

    const currencyLabel = computed(() => props.propCurrencyLabel)
    const projects = computed(() => props.propProjects)
    const allCriteria = computed(() => props.propAllCriteria)
    const comparableScenarios = computed(() => props.propComparableScenarios)
    const searchPhrase = computed(() => props.propSearchPhrase ?? null)
    const projectsFilter = computed(() => props.propProjectsFilter ?? null)

    const criteria = computed<SelectionCriterionReadModel[]>(() =>
    {
        if (criteriaFilter.value === 'Objectives')
            return allCriteria.value.filter(a => a.IsTop)

        if (criteriaFilter.value === 'Attributes')
            return allCriteria.value.filter(a => a.IsBottom)

        if (criteriaFilter.value === 'All criteria')
            return allCriteria.value.filter(a => !a.IsGoal)

        return []
    })

    const comparableProjects = computed(() =>
        [...projects.value]
            .sort((a, b) =>
                numCompare(
                    a.ComparableScenariosAcceptanceValue,
                    b.ComparableScenariosAcceptanceValue
                )
            )
            .reverse()
    )

    const criteriaFilterVisible = computed(() => projectsDataView.value === 'RAG')
    const criterionSelectorVisible = computed(() => projectsDataView.value === 'Ranking')
    const valueFilterVisible = computed(() => projectsDataView.value === 'Ranking')

    const valueFilterLabel = computed(() =>
        valueFilter.value == null ? 'All' : `Value > ${valueFilter.value}`
    )

    const selectedCriterion = computed<SelectionCriterionReadModel>(() =>
        allCriteria.value.find(a => a.Id === criterionId.value)
        ?? allCriteria.value.find(a => a.ParentId == null)!
    )

    const rankingProjects = computed(() =>
    {
        let view = [...projects.value]

        if (valueFilter.value != null)
        {
            view = view.filter(p =>
                p.NormalizedCriteriaValues[selectedCriterion.value.ValueIndex] >= valueFilter.value!
            )
        }

        return view
            .sort((a, b) =>
                numCompare(
                    a.NormalizedCriteriaValues[selectedCriterion.value.ValueIndex],
                    b.NormalizedCriteriaValues[selectedCriterion.value.ValueIndex]
                )
            )
            .reverse()
    })

    const subcriteria = computed(() =>
        allCriteria.value.filter(a => a.ParentId === selectedCriterion.value.Id)
    )

    const criterionLabel = computed(() => selectedCriterion.value.Name)

    // ---------------- actions / helpers ----------------

    function updateSearchPhrase(value: string | null)
    {
        emit('update-search-phrase', value)
    }

    function updateProjectsFilter(filter: string)
    {
        emit('update-projects-filter', filter)
    }

    function showCriterionSelector()
    {
        criterionSelectorDialog.show(criterionId.value, allCriteria.value)
    }

    function formatValue(val: number | null): string
    {
        return val?.toLocaleString('en', { maximumFractionDigits: 1 }) ?? ''
    }

    function getRagClass(val: number | null): string
    {
        if (val == null) return ''

        if (val < 25) return 'table-danger'
        if (val < 75) return 'table-warning'
        return 'table-success'
    }

    function getCompareAcceptanceClass(val: string | null): string
    {
        if (val === ProjectAcceptance.Rejected.toString()) return 'table-danger'
        if (val === ProjectAcceptance.TBD.toString()) return 'table-warning'
        if (val === ProjectAcceptance.Accepted.toString()) return 'table-success'
        return ''
    }

    function getCriterionBarColor(c: SelectionCriterionReadModel): string
    {
        return getDistinctBgCss(c.ValueIndex)
    }

    function getCriterionColor(c: SelectionCriterionReadModel): string
    {
        return getDistinctColor(c.ValueIndex)
    }

    function getAcceptanceButtonCss(p: SelectionProjectReadModel, btn: 'Accepted' | 'Rejected' | 'TBD')
    {
        const base = 'btn btn-sm btn-secondary'
        return p.UiAcceptance === btn ? base : 'btn btn-sm btn-outline-secondary'
    }

    function acceptSelection(p: SelectionProjectReadModel)
    {
        emit('accept-selection', p)
    }

    function rejectSelection(p: SelectionProjectReadModel)
    {
        emit('reject-selection', p)
    }

    function lockSelection(p: SelectionProjectReadModel)
    {
        emit('lock-selection', p)
    }

    function unlockSelection(p: SelectionProjectReadModel)
    {
        emit('unlock-selection', p)
    }

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CriterionSelectorDialog, {
      viewModel: _unref(criterionSelectorDialog),
      onConfirmSelection: _cache[0] || (_cache[0] = ($event: any) => (criterionId.value = $event))
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", _hoisted_6, _toDisplayString(projectsDataView.value), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (projectsDataView.value = 'CBA'))
                }, "Cost-Benefit Analysis"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (projectsDataView.value = 'RAG'))
                }, "Heatmap"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (projectsDataView.value = 'Ranking'))
                }, "Ranking"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (projectsDataView.value = 'H2H'))
                }, "Compare scenarios")
              ])
            ])
          ])
        ]),
        (criteriaFilterVisible.value === true)
          ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", _hoisted_11, _toDisplayString(criteriaFilter.value), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (criteriaFilter.value = 'Objectives'))
                    }, "Objectives (top)"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (criteriaFilter.value = 'Attributes'))
                    }, "Attributes (bottom)"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (criteriaFilter.value = 'All criteria'))
                    }, "All criteria")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (criterionSelectorVisible.value === true)
          ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
              _createElementVNode("div", { class: "navbar-form" }, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary",
                  type: "button",
                  onClick: showCriterionSelector
                }, "Criterion")
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (valueFilterVisible.value === true)
          ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", _hoisted_17, "Value: " + _toDisplayString(valueFilter.value ?? 'Any'), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (valueFilter.value = null))
                    }, "All"),
                    _cache[16] || (_cache[16] = _createElementVNode("h6", { class: "dropdown-header" }, "By value", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (valueFilter.value = 75))
                    }, "Above 75"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (valueFilter.value = 50))
                    }, "Above 50")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("ul", _hoisted_19, [
        _createElementVNode("li", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", _hoisted_23, "Filter: " + _toDisplayString(projectsFilter.value), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (updateProjectsFilter('All')))
                }, "All"),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                _cache[18] || (_cache[18] = _createElementVNode("h6", { class: "dropdown-header" }, "Filter by status:", -1 /* CACHED */)),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (updateProjectsFilter('TBD')))
                }, "TBD"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (updateProjectsFilter('Accepted')))
                }, "Accepted"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (updateProjectsFilter('Rejected')))
                }, "Rejected")
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("form", _hoisted_25, [
        _createElementVNode("input", {
          class: "form-control mr-sm-2",
          type: "search",
          placeholder: "Search",
          value: searchPhrase.value,
          onInput: _cache[15] || (_cache[15] = ($event: any) => (updateSearchPhrase($event.target.value)))
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_26)
      ])
    ]),
    (projectsDataView.value === 'CBA')
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("table", _hoisted_29, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[23] || (_cache[23] = _createElementVNode("th", {
                    class: "align-middle",
                    style: {"min-width":"300px","width":"300px","max-width":"300px"}
                  }, "Project", -1 /* CACHED */)),
                  _cache[24] || (_cache[24] = _createElementVNode("th", {
                    class: "text-center align-middle",
                    style: {"min-width":"100px","width":"100px","max-width":"100px"}
                  }, "P&L", -1 /* CACHED */)),
                  _cache[25] || (_cache[25] = _createElementVNode("th", {
                    class: "text-center align-middle",
                    style: {"min-width":"250px","width":"250px","max-width":"250px"}
                  }, "Selection", -1 /* CACHED */)),
                  _createElementVNode("th", _hoisted_30, [
                    _cache[19] || (_cache[19] = _createTextVNode("Cost of value point ", -1 /* CACHED */)),
                    _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createTextVNode(" (" + _toDisplayString(currencyLabel.value) + ")", 1 /* TEXT */)
                  ]),
                  _createElementVNode("th", _hoisted_31, [
                    _cache[21] || (_cache[21] = _createTextVNode("Costs ", -1 /* CACHED */)),
                    _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createTextVNode(" (" + _toDisplayString(currencyLabel.value) + ")", 1 /* TEXT */)
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("th", {
                    class: "align-middle",
                    style: {"min-width":"250px","width":"auto"}
                  }, [
                    _createTextVNode("Value "),
                    _createElementVNode("br"),
                    _createTextVNode(" (0-100)")
                  ], -1 /* CACHED */))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (a) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: a.Id
                  }, [
                    _createElementVNode("td", _hoisted_32, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_33, [
                        _createTextVNode(_toDisplayString(a.Name), 1 /* TEXT */)
                      ])), [
                        [_directive_sanitizedHref, a.DashboardUrl]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_34, [
                      (a.PlanId)
                        ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_35, [...(_cache[27] || (_cache[27] = [
                            _createTextVNode(" View ", -1 /* CACHED */)
                          ]))])), [
                            [_directive_sanitizedHref, a.PnlUrl]
                          ])
                        : _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_36, [...(_cache[28] || (_cache[28] = [
                            _createTextVNode(" NA ", -1 /* CACHED */)
                          ]))])), [
                            [_directive_sanitizedHref, a.PlansUrl]
                          ])
                    ]),
                    _createElementVNode("td", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(getAcceptanceButtonCss(a, 'Accepted')),
                          onClick: ($event: any) => (acceptSelection(a)),
                          disabled: a.UiAcceptanceLocked === true
                        }, "Accept", 10 /* CLASS, PROPS */, _hoisted_39),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(getAcceptanceButtonCss(a, 'Rejected')),
                          onClick: ($event: any) => (rejectSelection(a)),
                          disabled: a.UiAcceptanceLocked === true
                        }, "Reject", 10 /* CLASS, PROPS */, _hoisted_40)
                      ]),
                      (a.UiAcceptanceLocked === true)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-outline-secondary btn-sm",
                            onClick: ($event: any) => (unlockSelection(a))
                          }, [...(_cache[29] || (_cache[29] = [
                            _createElementVNode("i", { class: "fa-solid fa-lock" }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_41))
                        : _createCommentVNode("v-if", true),
                      (a.UiAcceptanceLocked === false)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-outline-secondary btn-sm",
                            title: "Click to lock selection status",
                            disabled: a.UiAcceptance === 'TBD',
                            onClick: ($event: any) => (lockSelection(a))
                          }, [...(_cache[30] || (_cache[30] = [
                            _createElementVNode("i", { class: "fa-solid fa-lock-open" }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_42))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("td", _hoisted_43, _toDisplayString(a.CostOfValuePointString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", {
                          class: "progress-bar bg-danger",
                          role: "progressbar",
                          style: _normalizeStyle({width: a.NormalizedTotalCost + '%'})
                        }, _toDisplayString(a.TotalCostString), 5 /* TEXT, STYLE */)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", {
                          class: "progress-bar bg-success",
                          role: "progressbar",
                          style: _normalizeStyle({width: a.TotalValue + '%'})
                        }, _toDisplayString(a.TotalValueString), 5 /* TEXT, STYLE */)
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (projectsDataView.value === 'RAG')
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("table", _hoisted_50, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[31] || (_cache[31] = _createElementVNode("th", {
                    class: "align-middle",
                    style: {"min-width":"300px","width":"300px","max-width":"300px"}
                  }, "Project", -1 /* CACHED */)),
                  _cache[32] || (_cache[32] = _createElementVNode("th", {
                    class: "text-center align-middle",
                    style: {"min-width":"100px","width":"100px","max-width":"100px"}
                  }, "P&L", -1 /* CACHED */)),
                  _cache[33] || (_cache[33] = _createElementVNode("th", {
                    class: "text-center align-middle",
                    style: {"min-width":"250px","width":"250px","max-width":"250px"}
                  }, "Selection", -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criteria.value, (c) => {
                    return (_openBlock(), _createElementBlock("th", {
                      class: "text-center align-middle",
                      key: c.Id,
                      style: {"min-width":"300px","width":"auto"}
                    }, _toDisplayString(c.Name), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (a) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: a.Id
                  }, [
                    _createElementVNode("td", _hoisted_51, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_52, [
                        _createTextVNode(_toDisplayString(a.Name), 1 /* TEXT */)
                      ])), [
                        [_directive_sanitizedHref, a.DashboardUrl]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_53, [
                      (a.PlanId)
                        ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_54, [...(_cache[34] || (_cache[34] = [
                            _createTextVNode(" View ", -1 /* CACHED */)
                          ]))])), [
                            [_directive_sanitizedHref, a.PnlUrl]
                          ])
                        : _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_55, [...(_cache[35] || (_cache[35] = [
                            _createTextVNode(" NA ", -1 /* CACHED */)
                          ]))])), [
                            [_directive_sanitizedHref, a.PlansUrl]
                          ])
                    ]),
                    _createElementVNode("td", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(getAcceptanceButtonCss(a, 'Accepted')),
                          onClick: ($event: any) => (acceptSelection(a)),
                          disabled: a.UiAcceptanceLocked === true
                        }, "Accept", 10 /* CLASS, PROPS */, _hoisted_58),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(getAcceptanceButtonCss(a, 'Rejected')),
                          onClick: ($event: any) => (rejectSelection(a)),
                          disabled: a.UiAcceptanceLocked === true
                        }, "Reject", 10 /* CLASS, PROPS */, _hoisted_59)
                      ]),
                      (a.UiAcceptanceLocked === true)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-outline-secondary btn-sm",
                            onClick: ($event: any) => (unlockSelection(a))
                          }, [...(_cache[36] || (_cache[36] = [
                            _createElementVNode("i", { class: "fa-solid fa-lock" }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_60))
                        : _createCommentVNode("v-if", true),
                      (a.UiAcceptanceLocked === false)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-outline-secondary btn-sm",
                            title: "Click to lock selection status",
                            disabled: a.UiAcceptance === 'TBD',
                            onClick: ($event: any) => (lockSelection(a))
                          }, [...(_cache[37] || (_cache[37] = [
                            _createElementVNode("i", { class: "fa-solid fa-lock-open" }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_61))
                        : _createCommentVNode("v-if", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criteria.value, (c) => {
                      return (_openBlock(), _createElementBlock("td", {
                        class: _normalizeClass(["text-center align-middle", getRagClass(a.NormalizedCriteriaValues[c.ValueIndex])]),
                        key: c.Id,
                        style: {"min-width":"300px","width":"auto"}
                      }, _toDisplayString(formatValue(a.NormalizedCriteriaValues[c.ValueIndex])), 3 /* TEXT, CLASS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (projectsDataView.value === 'H2H')
      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("table", _hoisted_64, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[38] || (_cache[38] = _createElementVNode("th", {
                    class: "align-middle",
                    style: {"min-width":"300px","width":"300px","max-width":"300px"}
                  }, "Project", -1 /* CACHED */)),
                  _cache[39] || (_cache[39] = _createElementVNode("th", {
                    class: "text-center align-middle",
                    style: {"min-width":"100px","width":"100px","max-width":"100px"}
                  }, "P&L", -1 /* CACHED */)),
                  _cache[40] || (_cache[40] = _createElementVNode("th", {
                    class: "text-center align-middle",
                    style: {"min-width":"250px","width":"250px","max-width":"250px"}
                  }, "Selection", -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comparableScenarios.value, (s) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: s.Id
                    }, _toDisplayString(s.Name), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comparableProjects.value, (a) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: a.Id
                  }, [
                    _createElementVNode("td", _hoisted_65, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_66, [
                        _createTextVNode(_toDisplayString(a.Name), 1 /* TEXT */)
                      ])), [
                        [_directive_sanitizedHref, a.DashboardUrl]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_67, [
                      (a.PlanId)
                        ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_68, [...(_cache[41] || (_cache[41] = [
                            _createTextVNode(" View ", -1 /* CACHED */)
                          ]))])), [
                            [_directive_sanitizedHref, a.PnlUrl]
                          ])
                        : _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_69, [...(_cache[42] || (_cache[42] = [
                            _createTextVNode(" NA ", -1 /* CACHED */)
                          ]))])), [
                            [_directive_sanitizedHref, a.PlansUrl]
                          ])
                    ]),
                    _createElementVNode("td", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(getAcceptanceButtonCss(a, 'Accepted')),
                          onClick: ($event: any) => (acceptSelection(a)),
                          disabled: a.UiAcceptanceLocked === true
                        }, "Accept", 10 /* CLASS, PROPS */, _hoisted_72),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(getAcceptanceButtonCss(a, 'Rejected')),
                          onClick: ($event: any) => (rejectSelection(a)),
                          disabled: a.UiAcceptanceLocked === true
                        }, "Reject", 10 /* CLASS, PROPS */, _hoisted_73)
                      ]),
                      (a.UiAcceptanceLocked === true)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-outline-secondary btn-sm",
                            onClick: ($event: any) => (unlockSelection(a))
                          }, [...(_cache[43] || (_cache[43] = [
                            _createElementVNode("i", { class: "fa-solid fa-lock" }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_74))
                        : _createCommentVNode("v-if", true),
                      (a.UiAcceptanceLocked === false)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-outline-secondary btn-sm",
                            title: "Click to lock selection status",
                            disabled: a.UiAcceptance === 'TBD',
                            onClick: ($event: any) => (lockSelection(a))
                          }, [...(_cache[44] || (_cache[44] = [
                            _createElementVNode("i", { class: "fa-solid fa-lock-open" }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_75))
                        : _createCommentVNode("v-if", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comparableScenarios.value, (s) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: s.Id,
                        class: _normalizeClass(["align-middle", getCompareAcceptanceClass(a.ComparableScenariosAcceptance[s.ValueIndex])]),
                        style: {"min-width":"250px","width":"auto"}
                      }, _toDisplayString(a.ComparableScenariosAcceptance[s.ValueIndex]), 3 /* TEXT, CLASS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (projectsDataView.value === 'Ranking')
      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
          _createElementVNode("table", _hoisted_77, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[46] || (_cache[46] = _createElementVNode("th", {
                  class: "align-middle",
                  style: {"min-width":"300px","width":"300px","max-width":"300px"}
                }, "Project", -1 /* CACHED */)),
                _cache[47] || (_cache[47] = _createElementVNode("th", {
                  class: "text-center align-middle",
                  style: {"min-width":"100px","width":"100px","max-width":"100px"}
                }, "P&L", -1 /* CACHED */)),
                _cache[48] || (_cache[48] = _createElementVNode("th", {
                  class: "text-center align-middle",
                  style: {"min-width":"250px","width":"250px","max-width":"250px"}
                }, "Selection", -1 /* CACHED */)),
                _cache[49] || (_cache[49] = _createElementVNode("th", {
                  class: "text-center align-middle",
                  style: {"min-width":"150px","width":"150px","max-width":"150px"}
                }, "Value", -1 /* CACHED */)),
                _createElementVNode("th", _hoisted_78, [
                  _createTextVNode(_toDisplayString(criterionLabel.value) + " ", 1 /* TEXT */),
                  (selectedCriterion.value.IsBottom === false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, [
                          _cache[45] || (_cache[45] = _createElementVNode("button", {
                            "data-toggle": "dropdown",
                            class: "btn btn-secondary btn-sm"
                          }, " Legend ", -1 /* CACHED */)),
                          _createElementVNode("div", _hoisted_81, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subcriteria.value, (c) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "dropdown-item-text font-weight-normal",
                                key: c.Id
                              }, [
                                _createElementVNode("i", {
                                  class: "fa fa-square",
                                  "aria-hidden": "true",
                                  style: _normalizeStyle({color: getCriterionColor(c)})
                                }, null, 4 /* STYLE */),
                                _createTextVNode(" " + _toDisplayString(c.Name), 1 /* TEXT */)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rankingProjects.value, (a) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: a.Id
                }, [
                  _createElementVNode("td", _hoisted_82, [
                    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_83, [
                      _createTextVNode(_toDisplayString(a.Name), 1 /* TEXT */)
                    ])), [
                      [_directive_sanitizedHref, a.DashboardUrl]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_84, [
                    (a.HasActivePlan)
                      ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_85, [...(_cache[50] || (_cache[50] = [
                          _createTextVNode(" View ", -1 /* CACHED */)
                        ]))])), [
                          [_directive_sanitizedHref, a.PnlUrl]
                        ])
                      : _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_86, [...(_cache[51] || (_cache[51] = [
                          _createTextVNode(" NA ", -1 /* CACHED */)
                        ]))])), [
                          [_directive_sanitizedHref, a.PlansUrl]
                        ])
                  ]),
                  _createElementVNode("td", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(getAcceptanceButtonCss(a, 'Accepted')),
                        onClick: ($event: any) => (acceptSelection(a)),
                        disabled: a.UiAcceptanceLocked === true
                      }, "Accept", 10 /* CLASS, PROPS */, _hoisted_89),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(getAcceptanceButtonCss(a, 'Rejected')),
                        onClick: ($event: any) => (rejectSelection(a)),
                        disabled: a.UiAcceptanceLocked === true
                      }, "Reject", 10 /* CLASS, PROPS */, _hoisted_90)
                    ]),
                    (a.UiAcceptanceLocked === true)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: ($event: any) => (unlockSelection(a))
                        }, [...(_cache[52] || (_cache[52] = [
                          _createElementVNode("i", { class: "fa-solid fa-lock" }, null, -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_91))
                      : _createCommentVNode("v-if", true),
                    (a.UiAcceptanceLocked === false)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn btn-outline-secondary btn-sm",
                          title: "Click to lock selection status",
                          disabled: a.UiAcceptance === 'TBD',
                          onClick: ($event: any) => (lockSelection(a))
                        }, [...(_cache[53] || (_cache[53] = [
                          _createElementVNode("i", { class: "fa-solid fa-lock-open" }, null, -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_92))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("td", _hoisted_93, _toDisplayString(formatValue(a.NormalizedCriteriaValues[selectedCriterion.value.ValueIndex])), 1 /* TEXT */),
                  _createElementVNode("td", null, [
                    (!selectedCriterion.value.IsBottom)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subcriteria.value, (c) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: c.Id,
                              title: c.Name,
                              class: _normalizeClass(["progress-bar", getCriterionBarColor(c)]),
                              role: "progressbar",
                              style: _normalizeStyle({width: a.LocalWeightedCriteriaValues[c.ValueIndex] + '%'})
                            }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_95))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    (selectedCriterion.value.IsBottom)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                          _createElementVNode("div", {
                            class: "progress-bar",
                            role: "progressbar",
                            style: _normalizeStyle({width: a.NormalizedCriteriaValues[selectedCriterion.value.ValueIndex] + '%'})
                          }, null, 4 /* STYLE */)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})